import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"0 15px"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import { BannerItem, useNavigation } from '@/view/home/supportScript';
import { onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'bannerCard',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const { goToPath } = useNavigation()


const noticeCard1 = ref({
  url: '',
  redirectUrl: '',
  display: false
})
const noticeCard2 = ref({
  url: '',
  redirectUrl: '',
  display: false
})
const noticeCard3 = ref({
  url: '',
  redirectUrl: '',
  display: false
})
const props = __props

onMounted(() => {
  noticeCard1.value.url = props.itemData.notice1.url
  noticeCard1.value.redirectUrl = props.itemData.notice1.redirectUrl
  noticeCard1.value.display = props.itemData.notice1.display

  noticeCard2.value.url = props.itemData.notice2.url
  noticeCard2.value.redirectUrl = props.itemData.notice2.redirectUrl
  noticeCard2.value.display = props.itemData.notice2.display

  noticeCard3.value.url = props.itemData.notice3.url
  noticeCard3.value.redirectUrl = props.itemData.notice3.redirectUrl
  noticeCard3.value.display = props.itemData.notice3.display
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, { class: "home_banner" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_row, null, {
              default: _withCtx(() => [
                (noticeCard1.value.display)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 0,
                      span: "24",
                      style: {"padding-right":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: noticeCard1.value.url,
                          height: "90%",
                          alt: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToPath)(noticeCard1.value.redirectUrl)))
                        }, null, 8, _hoisted_2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (noticeCard2.value.display)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 1,
                      span: "24",
                      style: {"padding-right":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: noticeCard2.value.url,
                          height: "90%",
                          alt: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToPath)(noticeCard2.value.redirectUrl)))
                        }, null, 8, _hoisted_3)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (noticeCard3.value.display)
          ? (_openBlock(), _createBlock(_component_van_col, {
              key: 0,
              span: "12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: noticeCard3.value.url,
                  height: "90%",
                  alt: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToPath)(noticeCard3.value.redirectUrl)))
                }, null, 8, _hoisted_4)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})